import { Component } from '@angular/core';
import { RegionService } from '../../services/region.service';

@Component({
  selector: 'page-sms-terms',
  templateUrl: 'sms-terms.html',
})
export class SMSTermsPage {
  constructor(public regionService: RegionService) {}
}



// WEBPACK FOOTER //
// ./src/pages/sms-terms/sms-terms.ts